module.exports = __webpack_public_path__ + "static/media/bg_top_login.68e71d76.png";